import _cloneDeepWith from "lodash/cloneDeepWith";
import { DateTime } from "luxon";
import _isMatch from "lodash/isMatch";

export const testHelper: TestHelper = {
  navigateTo: () => {
    throw new Error("testHelper.navigateTo is not initialized yet");
  },
  serialize: (data: any) =>
    _cloneDeepWith(data, (value) => {
      if (DateTime.isDateTime(value)) {
        return {
          __type__: "DateTime",
          __value__: value.toISO(),
        };
      }
    }),
  _isMatch,
};
